import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserService from "../services/EmployeeService";
import Breadcrumb from "../components/Breadcrumb";
import { FaSquare, FaCheckSquare, FaMinusSquare } from "react-icons/fa";
import { IoMdArrowDropright } from "react-icons/io";
import TreeView, { flattenTree } from "react-accessible-treeview";
import cx from "classnames";
import StorageService from "../services/StorageService";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";

export default function EmployeeMenu() {
  const [user, setUser] = useState({});
  const [selected, setSelected] = useState([]);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);
  // const messageTimer = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const [employeeId] = useState(() => {
    // const id = localStorage.getItem("menuAccessUserId");
    return id ? Number(id) : StorageService.loginData().employeeId;
  });

  const [menuData, setMenuData] = useState(
    flattenTree({
      name: "",
      id: 890,
      children: [],
    })
  );
  var dataWithPredefinedIds = flattenTree({
    name: "",
    id: 890,
    children: [],
  });

  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectededKeys, setSelectedKeys] = useState([]);
  const [activeIds, setActiveIds] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);
  var active = [];
  var inactive = [];
  var allParents = [];

  useEffect(() => {
    fetchEmployeeById();
    fetchUserMenu();
  }, []);

  const fetchEmployeeById = async () => {
    setLoading(true);
    try {
      setUser({});
      const res = await UserService.getById(employeeId);
      setUser(res || {});
    } catch (err) {
      console.error("Error fetching users:", err);
      showMessage("Failed to fetch user", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserMenu = async () => {
    setLoading(true);
    try {
      const res = await UserService.getUserMenu(employeeId, "edit");
      dataWithPredefinedIds = flattenTree({
        name: "",
        id: 890,
        children: res.data,
      });
      setMenuData(dataWithPredefinedIds);
      handleExpandAll(res.data);
      var sel = getAllCheckedKeys(res.data);
      setSelectedKeys(sel);
      setDeletedIds(inactive);
      setActiveIds(active);
    } catch (err) {
      console.error("Error fetching users:", err);
      showMessage("Failed to fetch users", "error");
    } finally {
      setLoading(false);
    }
  };

  const getAllParentKeys = (nodes) => {
    let keys = [];
    nodes.forEach((node) => {
      if (node.children && node.children.length > 0) {
        keys.push(node.id);
        keys = keys.concat(getAllParentKeys(node.children));
      }
    });
    return keys;
  };

  const getAllCheckedKeys = (nodes) => {
    let keys = [];
    nodes.forEach((node) => {
      if (node.isActive) {
        keys.push(node.id);
        if (active.indexOf(node.id) < 0) active.push(node.id);
        if (node.children.filter((x) => x.isActive == 0).length > 0) {
          allParents.forEach((e) => (keys = keys.filter((x) => x != e)));
        }
        if (node.children && node.children.length > 0) {
          keys = keys.concat(getAllCheckedKeys(node.children));
        }
      } else {
        if (inactive.indexOf(node.id) < 0) inactive.push(node.id);
      }
    });
    return keys;
  };

  const handleExpandAll = (data) => {
    allParents = getAllParentKeys(data);
    setExpandedKeys(allParents);
  };

  const onNodeSelect = (node) => {
    const element = node.element;

    let _selectededKeys = [...selectededKeys];
    let _activeIds = [...activeIds];
    let _deletedIds = [...deletedIds];
    if (node.isSelected) {
      if (!_activeIds.includes(element.id)) {
        _activeIds.push(element.id);
        _deletedIds = _deletedIds.filter((x) => x !== element.id);
        _selectededKeys.push(element.id);
      }
      if (!_activeIds.includes(element.parent)) {
        _activeIds.push(element.parent);
        _deletedIds = _deletedIds.filter((x) => x !== element.parent);
        _selectededKeys.push(element.parent);
      }
      element.children.forEach(cid => {
        if (!_activeIds.includes(cid)) {
          _activeIds.push(cid);
          _deletedIds = _deletedIds.filter((x) => x !== cid);
          _selectededKeys.push(cid);
        }
      })
    } else {
      if (!_deletedIds.includes(element.id)) {
        _deletedIds.push(element.id);
        _activeIds = _activeIds.filter((x) => x !== element.id);
        _selectededKeys = _selectededKeys.filter((x) => x !== element.id);
      }
      if (!_deletedIds.includes(element.parent)) {
        // _deletedIds.push(element.parent);
        // _activeIds = _activeIds.filter((x) => x !== element.parent);
        // _selectededKeys = _selectededKeys.filter((x) => x !== element.parent);        
      }
      element.children.forEach(cid => {
        // if (!_deletedIds.includes(cid)) {
        _deletedIds.push(cid);
        _activeIds = _activeIds.filter((x) => x !== cid);
        _selectededKeys = _selectededKeys.filter((x) => x !== cid);
        // }
      })
    }

    setActiveIds(_activeIds);
    setDeletedIds(_deletedIds);
    setSelectedKeys(_selectededKeys);
  };

  const handleCollapseAll = () => {
    setExpandedKeys([]);
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const handleSelect = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );

  const handleSaveMenu = async () => {
    const payload = {
      id: employeeId,
      deletedIds: deletedIds,
      activeIds: activeIds,
    };

    try {
      setLoading(true);
      await UserService.updateUserMenu(payload);
      fetchUserMenu();
      showMessage("Menu updated successfully ", "success");
    } catch (err) {
      console.error(err);
      showMessage("Failed to update menu", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editItem");
    navigate("/cpnl/users/view");
  };

  function TreeViewComponent({ data }) {
    return (
      <div className="checkbox">
        <TreeView
          data={data}
          multiSelect
          propagateSelect={false}
          propagateSelectUpwards={false}
          togglableSelect={false}
          selectedIds={selectededKeys}
          expandedIds={[890, ...expandedKeys]}
          onNodeSelect={onNodeSelect}
          nodeRenderer={({
            element,
            isBranch,
            isExpanded,
            isSelected,
            isHalfSelected,
            getNodeProps,
            level,
            handleExpand,
          }) => {
            return (
              <div
                {...getNodeProps({
                  onClick: handleExpand, // ONLY expand/collapse
                })}
                style={{ marginLeft: 40 * (level - 1) }}
              >
                {isBranch && <ArrowIcon isOpen={isExpanded} />}

                {/* ✔️ custom checkbox selection (NO TreeView toggle conflict) */}
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    onNodeSelect({
                      element,
                      isSelected: !selectededKeys.includes(element.id),
                    });
                  }}
                  style={{ cursor: "pointer", marginRight: 8 }}
                >
                  <CheckBoxIcon
                    variant={
                      isHalfSelected ? "some" : isSelected ? "all" : "none"
                    }
                  />
                </span>

                <span className="name">{element.name}</span>
              </div>
            );
          }}
        />
      </div>
    );
  }

  const ArrowIcon = ({ isOpen, className }) => {
    const baseClass = "arrow";
    const classes = cx(
      baseClass,
      { [`${baseClass}--closed`]: !isOpen },
      { [`${baseClass}--open`]: isOpen },
      className
    );
    return <IoMdArrowDropright className={classes} />;
  };

  const CheckBoxIcon = ({ variant, ...rest }) => {
    switch (variant) {
      case "all":
        return <FaCheckSquare {...rest} />;
      case "none":
        return <FaSquare {...rest} />;
      case "some":
        return <FaMinusSquare {...rest} />;
      default:
        return null;
    }
  };

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";

  const getToggleText = (status) =>
    status === "Active" ? "Inactivate" : "Activate";

  return (
    <>
      <Breadcrumb
        pageTitle="Employee Menu"
        secondTitle="Employee Management"
      ></Breadcrumb>
      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center mb-2 p-2`}
        >
          <span>{message}</span>
          <button
            type="button"
            className="btn-close"
            onClick={closeMessage}
          ></button>
        </div>
      )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      
      <div className="">
        <div className="card bg-white shadow-sm">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <table className="table table-striped table-bordered mb-0">
                  <tbody className="table-light">
                    <tr>
                      <td>First Name</td>
                      <td>{user.firstName}</td>
                    </tr>
                    <tr>
                      <td>Last Name</td>
                      <td>{user.lastName}</td>
                    </tr>
                    <tr>
                      <td>Role / Designation</td>
                      <td>{user.roleName}</td>
                    </tr>
                    <tr>
                      <td>Mobile</td>
                      <td>{user.mobileNo}</td>
                    </tr>
                    <tr>
                      <td>e-Mail Id</td>
                      <td>{user.emailId}</td>
                    </tr>
                    <tr>
                      <td>Date of Joining</td>
                      <td>{user.doj
                         ? utility.formatDateDDMMMYYYY(user.doj)
                        : "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-6">
                <TreeViewComponent data={menuData} />
              </div>
            </div>
          </div>
          {["1", "2"].includes(StorageService.loginData().roleId)
            || (!["1", "2"].includes(StorageService.loginData().roleId)
              && employeeId != StorageService.loginData().employeeId) ?
            <div className="card-footer">
              <div
                className="float-end"
                style={{ borderBottom: "1px solid #e9ecef" }}
              >
                <button
                  className="d-inline-flex btn btn-success me-2"
                  onClick={handleSaveMenu}
                  disabled={loading}
                >
                  <i class="ti ti-circle-check me-1"></i> Update
                </button>
                <button
                  className="d-inline-flex btn btn-secondary me-2"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i class="ti ti-cancel me-1"></i> Cancel
                </button>
              </div>
            </div> : <></>}
        </div>
      </div>
    </>
  );
}
